<script>
import { fetchLangsByName } from '@apis/admin/lang'
import find from 'lodash/find'
import LangSearch from '@components/admin/lang-search'

export default {
  components: { LangSearch },
  props: {
    placeholder: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      langs: [],
      value_to_parent: '',
      show_dialog: false,
    }
  },
  computed: {
    lang_name() {
      const matches = this.$attrs.value.match(
        /^\{\{ user_lang\.([a-zA-Z][a-zA-Z0-9_]+) \}\}$/
      )

      if (!matches) return null

      return matches[1]
    },
    lang_value() {
      const lang = find(this.langs, { locale: 'ko-KR' })

      return lang ? lang.value : null
    },
  },
  watch: {
    '$attrs.value'(to) {
      this.value_to_parent = to
    },
    lang_name() {
      this.loadLangs().catch((e) => this.$toasted.error(e.message))
    },
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.value_to_parent = this.$attrs.value

      Promise.all([this.loadLangs()]).catch((e) =>
        this.$toasted.error(e.message)
      )
    },
    async loadLangs() {
      if (!this.lang_name) return

      const { langs } = await fetchLangsByName(this.lang_name)

      this.langs = langs
    },
    handleValueChange() {
      this.$emit('input', this.value_to_parent)
    },
    handleReset() {
      this.value_to_parent = ''
      this.handleValueChange()
    },
    handleSelect(name) {
      this.show_dialog = false
      this.value_to_parent = `{{ user_lang.${name} }}`
      this.handleValueChange()
    },
  },
}
</script>

<template>
  <div>
    <ElInput v-if="lang_name" v-model="lang_value" disabled>
      <ElButton
        slot="append"
        icon="el-icon-search"
        @click="show_dialog = true"
      ></ElButton>
      <ElButton
        slot="append"
        icon="el-icon-delete"
        @click="handleReset"
      ></ElButton>
    </ElInput>
    <ElInput
      v-else
      v-model="value_to_parent"
      :placeholder="placeholder"
      @change="handleValueChange"
    >
      <ElButton
        slot="append"
        icon="el-icon-search"
        @click="show_dialog = true"
      ></ElButton>
    </ElInput>
    <ElDialog
      :visible.sync="show_dialog"
      :append-to-body="true"
      width="1080px"
      :title="$t('admin.lang_search_select')"
    >
      <LangSearch
        :allow_select="true"
        :modal_check="true"
        @select="handleSelect"
      ></LangSearch>
    </ElDialog>
  </div>
</template>

<style lang="scss" module>
@import '@design';
</style>
